module.exports = __webpack_public_path__ + "static/media/privacy.35c9df34.svg";